import React from "react";
import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";

const StoreProdutsSettings = () => {
  return (
    <>
      <div className="hstack justify-content-between mb-2 pt-3 px-3 pb-1">
        <Form.Group>
          <h6 className="m-0 d-block">Inventory Settings</h6>
          <Form.Text style={{ fontSize: 12 }}>
            Manage how product stock is tracked and handled for your store.
          </Form.Text>
        </Form.Group>
        <Button size="sm">Save</Button>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 175px)" }}>
        <div className="px-3 pb-3">
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4">
              <Form.Group className="mb-2">
                <Row className="g-2">
                  <Col xs={12}>
                    <Form.Label className="m-0">SKU</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Stock keeping unit"
                      required
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Barcode</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="UPC / EAN (optional)"
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Stock Status</Form.Label>
                    <Form.Select style={{ fontSize: 13 }} required>
                      <option>In Stock</option>
                      <option>Out of Stock</option>
                      <option>Preorder</option>
                    </Form.Select>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Track Inventory</Form.Label>
                    <Form.Select style={{ fontSize: 13 }} required>
                      <option>Yes</option>
                      <option>No</option>
                    </Form.Select>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Quantity Available</Form.Label>
                    <Form.Control
                      type="number"
                      min={0}
                      placeholder="0"
                      required
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Low Stock Threshold</Form.Label>
                    <Form.Control
                      type="number"
                      min={0}
                      placeholder="5"
                      required
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Backorder Policy</Form.Label>
                    <Form.Select style={{ fontSize: 13 }} required>
                      <option>Do Not Allow</option>
                      <option>Allow</option>
                      <option>Allow With Notification</option>
                    </Form.Select>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Warehouse Location</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Aisle / Shelf (optional)"
                    />
                  </Col>
                </Row>
              </Form.Group>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default StoreProdutsSettings;
